/* IL CAPITANO — UX helpers LITE */
(function(){
  document.documentElement.classList.add('cap-ux-ready', 'cap-ux-lite');

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function(){
      document.documentElement.classList.add('cap-fonts-loaded');
    });
  }

  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.cap-ux-help-strip__search').forEach(function(form){
      form.addEventListener('submit', function(event){
        var input = form.querySelector('input[name="q"]');
        if (!input) return;
        if (!input.value.trim()){
          event.preventDefault();
          input.focus();
          form.classList.add('is-empty');
          window.setTimeout(function(){ form.classList.remove('is-empty'); }, 700);
        }
      });
    });
  });
})();
